export default class Bg {
    constructor() {
        this.$bg = document.getElementById('bg');

        MAIN.isVisit && this._init();
    }

    _init() {
        // 背景のアニメーションを開始
        this.setActive();

        // 背景がスクロールして一番上に来たら固定
        // this.setLock()
    }

    setActive() {
        this.$bg.classList.add('-active');
    }

    setLock() {
        const main = document.querySelector('.l-main');
        if (window.innerWidth <= 768)
            window.addEventListener('scroll', () => {
                if (main.getBoundingClientRect().top <= 0) {
                    this.$bg.style.position = 'fixed';
                } else {
                    this.$bg.style.position = 'absolute';
                }
            });
    }
}
